import { render, staticRenderFns } from "./case-tatics.vue?vue&type=template&id=6713e8b2"
import script from "./case-tatics.vue?vue&type=script&lang=ts"
export * from "./case-tatics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports